/** Provenance only; no local finance calculation or freshness timeout. */
import { accountFinanceReason, type AccountMoneyInputs } from "./accounts.ts";
export type MoneySources = { balance: string; realized: string; open: string; day: string };
export function accountMoneySources(m: AccountMoneyInputs): MoneySources {
  const reason = accountFinanceReason(m);
  const source = (value: bigint | undefined) =>
    reason || (value === undefined ? "Not reported by Rithmic" : "Rithmic P&L plant");
  return {
    balance: source(m.plant?.balanceCents),
    realized: source(m.plant?.realizedTodayCents),
    open: source(m.plant?.unrealizedCents),
    day: source(m.plant?.dayPnlCents),
  };
}
export function riskCoverage(input: { financeReason: string }): {
  label: string;
  detail: string;
  caution: boolean;
} {
  return input.financeReason
    ? {
        label: "Unavailable",
        detail: input.financeReason + ". Missing values do not mean zero.",
        caution: true,
      }
    : {
        label: "Rithmic finance",
        detail:
          "Only individually reported Rithmic fields are shown. Drawdown and daily-loss room are computed from Rithmic values only and stay unverified until matched against R|Trader Pro.",
        caution: false,
      };
}
